
import {defineComponent} from "vue";
import useStore from "@/composables/useStore";
import ComparableDiamondCard from "@/components/ComparableDiamondCard.vue";
import {Diamond} from "@/api/Diamond";

export default defineComponent({
    name: "ComparableDiamonds",
    components: {ComparableDiamondCard},
    setup() {
        const store = useStore();

        function handleSelectDiamond(diamond: Diamond) {
            store.actions.setDiamond(diamond);
        }

        return {
            selectedDiamond: store.computed.selectedDiamond,
            comparableDiamonds: store.computed.comparableDiamonds,
            handleSelectDiamond
        };
    }
});
